import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  getEndpointFromConfig,
  getHashForTopic,
  getTopicDescription,
} from '../../common/utils/helper'
import { endpointLabels, pillarNames } from '../../common/utils/enum'
import { fetchAndSetBoundaries } from '../../common/commonSlice'
import fetchData from '../../service/apiService'
import { TOPIC_LIST } from '../../common/utils/constants'
import {
  setCountryList,
  setSelectedPillar,
  setSelectedTopic,
  setSelectedView,
} from './dataHomepageSlice'
import TopicWorldMapWrapper from './TopicWorldmapWrapper'
import PillarWorldmapWrapper from './PillarWorldmapWrapper'
import TopicGrid from './dataViz/TopicGrid'
import PillarGrid from './dataViz/PillarGrid'
import DOMPurify from 'dompurify'

const DataHomepageWrapper = ({
  countryListJsonPath,
  countryProfileURLAuthor,
  countryProfileURLPublish,
  topicProfileURLAuthor,
  topicProfileURLPublish,
  logoPath,
  pillarDescriptionJsonPath,
  methodologyURLAuthor,
  methodologyURLPublish,
  countryCodes,
}) => {
  const {
    endpointList,
    mapApiKeyName,
    mapApiKeyValue,
    environment,
    topicDescription,
    methodologyHash,
  } = useSelector((state) => state.common)
  const { selectedTopic, selectedPillar, selectedView } = useSelector(
    (state) => state.dataHomepage
  )

  const [selectedTab, setSelectedTab] = useState('topic')
  const [showTopicInfo, setShowTopicInfo] = useState(false)
  const [showPillarInfo, setShowPillarInfo] = useState(false)
  const [pillarDescription, setPillarDescription] = useState(null)

  const dispatch = useDispatch()

  useEffect(() => {
    const fetchPillarDescription = async () => {
      try {
        const pillarDescription = await fetchData(pillarDescriptionJsonPath)
        setPillarDescription(pillarDescription)
      } catch (error) {}
    }
    if (pillarDescriptionJsonPath) {
      fetchPillarDescription()
    }
  }, [pillarDescriptionJsonPath])

  useEffect(() => {
    const fetchCountryList = async () => {
      try {
        const response = await fetchData(countryListJsonPath)
        const countryList = response.filter((item) => item.type === 'country')
        dispatch(setCountryList(countryList))
        if (
          endpointList &&
          endpointList.length > 0 &&
          mapApiKeyName &&
          mapApiKeyValue
        ) {
          fetchBoundaries(countryList)
        }
      } catch (error) {}
    }
    if (countryListJsonPath) {
      fetchCountryList()
    }
  }, [endpointList, mapApiKeyName, mapApiKeyValue, countryListJsonPath])

  const updateCountryCodesForMaps = (countryCodes, oldCode, newCode) => {
    return Array.from(countryCodes).reduce((acc, curr) => {
      if (curr === oldCode) {
        acc.push(newCode)
      } else {
        acc.push(curr)
      }
      return acc
    }, [])
  }
  const fetchBoundaries = async (countryList) => {
    if (countryList.length > 0) {
      let countryCodeSet = new Set(countryList.map((item) => item.id))
      // handle different codes for Romania, Timor-Leste and West Bank and Gaza for maps API -- start
      if (countryCodes && countryCodes.length > 0) {
        countryCodeSet = countryCodes.map((item) =>
          updateCountryCodesForMaps(
            countryCodeSet,
            item.breadyAPICode,
            item.mapAPICode
          )
        )
      }
      // handle different codes for Romania, Timor-Leste and West Bank and Gaza for maps API -- end
      const uniqueCountryCodes = Array.from(countryCodeSet).join(',')

      const headers = {
        [mapApiKeyName]: mapApiKeyValue,
      }
      dispatch(
        fetchAndSetBoundaries({
          endpoint: `${
            getEndpointFromConfig(endpointList, endpointLabels.Boundaries)
              ?.apiEndpoint
          }/${uniqueCountryCodes}`,
          headers: headers,
        })
      )
    }
  }
  const handleTopicClick = (topicName) => {
    dispatch(setSelectedTopic(topicName))
  }
  const handlePillarClick = (pillar) => {
    dispatch(setSelectedPillar(pillar))
  }
  const topicTabs = TOPIC_LIST.map((topic) => (
    <li
      key={`topic-${topic.name}`}
      onClick={() => handleTopicClick(topic.name)}
      className={selectedTopic === topic.name ? 'lp__selected' : ''}
    >
      <button>
        <i className={`lp ${topic.icon}`} aria-hidden="true"></i>
        <span>{topic.name}</span>
      </button>
    </li>
  ))
  const pillarTabs = pillarNames.map((pillar) => (
    <li
      key={`pillar-${pillar.datapointName}`}
      onClick={() => handlePillarClick(pillar.datapointName)}
      className={selectedPillar === pillar.datapointName ? 'lp__selected' : ''}
    >
      <button>
        {/* <i className={`lp ${topic.icon}`} aria-hidden="true"></i> */}
        {/* TO-DO: color circles for each pillar */}
        {pillar.pillarTitle}
        <span>{pillar.name}</span>
      </button>
    </li>
  ))
  return (
    <div className="lp__gray_container lp_data_topic_container">
      <div className="row">
        <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
          {/* TO-DO: view buttons(map view, grid view) */}
          <div className="lp-view-button-container">
            <button
              className={selectedView === 'map' ? 'selected-view' : ''}
              disabled={selectedView === 'map' ? true : undefined}
              onClick={() => dispatch(setSelectedView('map'))}
            >
              Map view
            </button>
            <button
              className={selectedView === 'grid' ? 'selected-view' : ''}
              disabled={selectedView === 'grid' ? true : undefined}
              onClick={() => dispatch(setSelectedView('grid'))}
            >
              Grid view
            </button>
          </div>
          {/* TO-DO: popup asking to select topic or pillar */}
          {((selectedTab === 'topic' && selectedTopic === '') ||
            (selectedTab === 'pillar' && selectedPillar === '')) && (
            <div
              className="select-data-window"
              style={{
                position: 'absolute',
                width: '300px',
                height: '100px',
                top: '150px',
                left: '150px',
                background: 'white',
                opacity: '0.9',
              }}
            >
              <div className="project-logo">
                <img
                  title="Bready logo"
                  alt="B ready logo"
                  src={logoPath}
                  className="img-responsive"
                />
              </div>
              <div className="selection-text">
                Select topic or pillar to see data
                <span className="lp lp-chevron-double-right"></span>
              </div>
            </div>
          )}
          {selectedTopic === '' && selectedPillar === '' && <></>}
          {selectedView === 'map' && selectedTab === 'topic' && (
            <TopicWorldMapWrapper
              countryProfileURLAuthor={countryProfileURLAuthor}
              countryProfileURLPublish={countryProfileURLPublish}
              countryCodes={countryCodes}
            />
          )}
          {selectedView === 'map' && selectedTab === 'pillar' && (
            <PillarWorldmapWrapper
              countryProfileURLAuthor={countryProfileURLAuthor}
              countryProfileURLPublish={countryProfileURLPublish}
              countryCodes={countryCodes}
            />
          )}
          {selectedView === 'grid' && selectedTab === 'topic' && (
            <TopicGrid
              countryProfileURLAuthor={countryProfileURLAuthor}
              countryProfileURLPublish={countryProfileURLPublish}
            />
          )}
          {selectedView === 'grid' && selectedTab === 'pillar' && (
            <PillarGrid
              countryProfileURLAuthor={countryProfileURLAuthor}
              countryProfileURLPublish={countryProfileURLPublish}
            />
          )}
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div className="lp_filter_collapse_inner_Content">
            {((selectedTab === 'topic' && selectedTopic === '') ||
              (selectedTab === 'pillar' && selectedPillar === '')) && (
              <div className="tab-title">{`Make ${selectedView} selection:`}</div>
            )}
            {/* TO-DO: 'You have selected:' text with selected topic or selected pillar */}
            {selectedTab === 'topic' && selectedTopic && (
              <>
                <div className="tab-title">You have selected:</div>
                <div className="tab-pillartitle">
                  <i
                    className={`lp ${
                      TOPIC_LIST.find(
                        (item) =>
                          item.name.toLowerCase() ===
                          selectedTopic.toLowerCase()
                      )?.icon
                    }`}
                    aria-hidden="true"
                  ></i>
                  {selectedTopic}
                  {/* TO-DO: info icon on selected topic name and selected pillar name */}
                  <span
                    className="lp lp-info-circle-solid"
                    onClick={() => setShowTopicInfo(true)}
                  />
                </div>
              </>
            )}
            {selectedTab === 'pillar' && selectedPillar && (
              <>
                <div className="tab-title">You have selected:</div>
                <div className="tab-pre-pillartitle">
                  {
                    pillarNames.find(
                      (item) =>
                        item.datapointName.toLowerCase() ===
                        selectedPillar.toLowerCase()
                    )?.pillarTitle
                  }
                </div>
                <div className="tab-pillartitle">
                  <span className={`${selectedPillar}_color`}></span>
                  {
                    pillarNames.find(
                      (item) =>
                        item.datapointName.toLowerCase() ===
                        selectedPillar.toLowerCase()
                    )?.name
                  }
                  <span
                    className="lp lp-info-circle-solid"
                    onClick={() => setShowPillarInfo(true)}
                  />
                </div>
              </>
            )}
            {showTopicInfo && (
              <div className="filter-tooltip">
                <a
                  href="#close"
                  className="close-window"
                  onClick={(event) => {
                    event.preventDefault()
                    setShowTopicInfo(false)
                  }}
                >
                  <span className="sr-only">Close window</span>
                </a>
                <div className="filter-tooltip-title">{`About ${selectedTopic}`}</div>
                <p>{getTopicDescription(topicDescription, selectedTopic)}</p>
                <a
                  href={
                    environment === 'author'
                      ? `${topicProfileURLAuthor}.${
                          TOPIC_LIST.find(
                            (item) =>
                              item.name.toLowerCase() ===
                              selectedTopic.toLowerCase()
                          )?.url
                        }.html`
                      : `${topicProfileURLPublish}/${
                          TOPIC_LIST.find(
                            (item) =>
                              item.name.toLowerCase() ===
                              selectedTopic.toLowerCase()
                          )?.url
                        }`
                  }
                >
                  Visit topic page for more information
                </a>
                <div className="lp_link_text">
                  <a
                    href={
                      environment === 'author'
                        ? `${methodologyURLAuthor}#${getHashForTopic(
                            selectedTopic,
                            methodologyHash
                          )}`
                        : `${methodologyURLPublish}#${getHashForTopic(
                            selectedTopic,
                            methodologyHash
                          )}`
                    }
                  >
                    See the topic methodology
                  </a>
                </div>
              </div>
            )}
            {showPillarInfo && (
              <div className="filter-tooltip">
                <a
                  href="#close"
                  className="close-window"
                  onClick={(event) => {
                    event.preventDefault()
                    setShowPillarInfo(false)
                  }}
                >
                  <span className="sr-only">Close window</span>
                </a>
                <div className="filter-tooltip-title">{`About ${
                  pillarNames.find(
                    (item) =>
                      item.datapointName.toLowerCase() ===
                      selectedPillar.toLowerCase()
                  )?.name
                }`}</div>
                {pillarDescription && pillarDescription.length > 0 && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(pillarDescription.find(
                        (item) =>
                          item.id.toLowerCase() === selectedPillar.toLowerCase()
                      )?.description),
                    }}
                  ></p>
                )}
              </div>
            )}
            {((selectedTab === 'topic' && !showTopicInfo) ||
              (selectedTab === 'pillar' && !showPillarInfo)) && (
              <div className="tab lp__chart_tab__component">
                <div
                  className="lp__tab parbase section"
                  aria-label="latest tab"
                >
                  <div id="tabOffsetWrapper">
                    <div className="lp__tab_components">
                      <div className="lp__wrapper">
                        <div className="lp__scroller lp__scroller_left">
                          {' '}
                          <i
                            className="lp lp-chevron-double-left"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <div className="lp__scroller lp__scroller_right">
                          {' '}
                          <i
                            className="lp lp-chevron-double-right"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <ul className="lp__tablist" role="tablist">
                          <li
                            role="presentation"
                            onClick={() => setSelectedTab('topic')}
                          >
                            <a
                              data-wbgtabidtabheader="1"
                              href="#1"
                              role="tab"
                              data-customlink="tb:body content"
                              aria-selected={
                                selectedTab === 'topic' ? 'true' : 'false'
                              }
                              aria-controls="1-tab"
                              id="tab1"
                              className=""
                              onClick={(event) => event.preventDefault()}
                            >
                              Topics
                            </a>
                          </li>
                          <li
                            role="presentation"
                            onClick={() => setSelectedTab('pillar')}
                          >
                            <a
                              data-wbgtabidtabheader="2"
                              className=""
                              href="#2"
                              role="tab"
                              data-customlink="tb:body content"
                              aria-selected={
                                selectedTab === 'pillar' ? 'true' : 'false'
                              }
                              aria-controls="2-tab"
                              id="tab2"
                              tabIndex="-1"
                              onClick={(event) => event.preventDefault()}
                            >
                              Pillars
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="lp__tabcontent">
                        {selectedTab === 'topic' && (
                          <div
                            className="tab_wbr"
                            data-wbgtabidtabcontent="1"
                            tabIndex="0"
                            role="tabpanel"
                            id="1-tab"
                            aria-labelledby="tab1"
                          >
                            <div className="lp__chart_input_wrapper explore-tab">
                              <ul>{topicTabs}</ul>
                            </div>
                          </div>
                        )}
                        {selectedTab === 'pillar' && (
                          <div
                            className="tab_wbr"
                            data-wbgtabidtabcontent="2"
                            tabIndex="0"
                            role="tabpanel"
                            id="2-tab"
                            aria-labelledby="tab2"
                          >
                            <div className="lp__chart_input_wrapper explore-tab">
                              <ul>{pillarTabs}</ul>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default DataHomepageWrapper
